function cov_1nrjtjdii6() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/NavHamburgerIcon.tsx";
  var hash = "cf6e2d6ab8719fd7cd8b68273c2e52ce67b93f2c";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_icons/NavHamburgerIcon.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 40
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 20,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 7,
            column: 41
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 20,
            column: 9
          }
        },
        line: 8
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cf6e2d6ab8719fd7cd8b68273c2e52ce67b93f2c"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1nrjtjdii6 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1nrjtjdii6();
import React from 'react';
import { Flex } from '../../core';
import { colors } from '../../theme/eero';
/** @deprecated */

cov_1nrjtjdii6().s[0]++;

var NavHamburgerIcon = function NavHamburgerIcon(props) {
  cov_1nrjtjdii6().f[0]++;
  cov_1nrjtjdii6().s[1]++;
  return /*#__PURE__*/React.createElement(Flex, props, /*#__PURE__*/React.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "menu"), /*#__PURE__*/React.createElement("path", {
    d: "M8.18271 11.0627H5.81729H1.18271C0.529516 11.0627 0 11.7203 0 12.5314C0 13.3425 0.529516 14 1.18271 14H5.81729H8.18271H12.8173C13.4705 14 14 13.3425 14 12.5314C14 11.7203 13.4705 11.0627 12.8173 11.0627H8.18271Z",
    fill: colors.brand50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18271 0H5.81729H1.18271C0.529516 0 0 0.657521 0 1.46861C0 2.27971 0.529516 2.93723 1.18271 2.93723H5.81729H8.18271H12.8173C13.4705 2.93723 14 2.27971 14 1.46861C14 0.657521 13.4705 0 12.8173 0H8.18271Z",
    fill: colors.brand50
  })));
};

export default NavHamburgerIcon;